<script setup>
import SectionTitle from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/components/SectionTitle.vue'

const { getNuxtLink, isExternal } = useCustomLink()
const cityList = ref([])
const props = defineProps({
  pref: {
    type: String,
    default: ''
  }
})

const cityListData = await useFetch('/api/city/cityList', { query: { pref: props.pref } })
cityList.value = cityListData.data.value || []
</script>

<template>
  <article
    v-if="cityList.length > 0"
    class="areaLinks"
  >
    <SectionTitle title="市区町村別の服装予報" />
    <div class="inner">
      <div
        v-for="block in cityList"
        :key="block.primary_subdivision_code"
        class="block"
      >
        <h3 class="area">
          {{ block.primary_subdivision_name }}
        </h3>
        <ul class="links">
          <li
            v-for="city in block.pointlist"
            :key="city.citycode"
          >
            <NuxtLink
              :to="getNuxtLink(city.link)"
              :external="isExternal(city.link)"
              class="link"
            >{{ city.cityname }}</NuxtLink>
          </li>
        </ul>
      </div>
    </div>
  </article>
</template>

  <style lang="scss" scoped>
  .areaLinks {
    display: flex;
    flex-direction: column;
    gap: 10px;
    .inner {
      display: flex;
      flex-direction: column;
      gap: 20px;
      padding: 15px;
      border-radius: 8px;
      background-color: #eef1f8;
    }
    .block {
      display: flex;
      gap: 15px;
    }
    .area {
      color: #303030;
      font-weight: 700;
    }
    .links {
      display: flex;
      flex-wrap: wrap;
      flex: 1;
      gap: 8px;
    }
    .link {
      display: block;
      padding: 7px 10px;
      border-radius: 8px;
      background-color: #fff;
      box-shadow: 0 2px 4px 0 rgb(0 0 0 / .25);
      font-size: 12px;
      font-weight: 700;
      line-height: 1em;
      letter-spacing: .025em;
    }
    @media (any-hover: hover) {
      .link {
        transition: opacity .2s ease-in-out;
        &:hover {
          opacity: .6;
        }
      }
    }
  }
  .main {
    .areaLinks {
      @media (min-width: 830px) {
        .link {
          font-size: 13px;
          letter-spacing: normal;
        }
      }
    }
  }
  </style>
